import { Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";

const OliviaJonMessage = () => {
  return (
    <div className="other-msg">
      <div className="d-flex">
        <Image className="img-50 img-fluid m-r-20 rounded-circle" alt="user" src={dynamicImage("user/3.png")} />
        <div className="flex-grow-1">
          <span className="f-w-600">Olivia Jon&nbsp;<span>15 Days Ago <i className="fa fa-reply font-primary" /></span>
          </span>
          <P>i like lexus cars, lexus cars are most beautiful with the awesome features, but this car is really outstanding than lexus</P>
        </div>
      </div>
    </div>
  );
};

export default OliviaJonMessage;
